// extracted by mini-css-extract-plugin
export default {"active":"FullScreen_active__HLjrz"};